import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { marketingMobileCuttoff } from '@css/constants'

export const ImageBlockWrapper = styled('div')(css`
  width: calc(100% - 32px);
  margin: 0 auto;
`)

export const ImageWrapper = styled('div')<{ isActionable: boolean }>(props => css`
  cursor: ${props.isActionable ? 'pointer' : 'none'};
  outline: none;
  transition: opacity 400ms ease;

  &:hover {
    opacity: ${props.isActionable ? 0.8 : 1};
  }
`)

interface InfoBlockImageProps {
  imageUrl: string
  imageUrlMobile?: string
  imageHeight?: string
  imageHeightMobile?: string
  imageMarginBottomMobile?: string
}

export const Image = styled('div')<InfoBlockImageProps>((props) => css`
  width: 100%;
  height: ${props.imageHeight || '100px'};
  margin: 0 auto;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${props.imageUrl});

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-top: 20px;
    margin-bottom: ${props.imageMarginBottomMobile || '0'};
    height: ${props.imageHeightMobile || props.imageHeight || '100px'};
    background-image: url(${props.imageUrlMobile || props.imageUrl});
  }
`)
